(function () {
  var TZ = 'Europe/Paris';
  // Deux jeux de libelles : la fourchette de livraison est abregee pour tenir sur une ligne,
  // la date de precommande reste en entier car c'est une date unique et engageante.
  // Abreviations francaises usuelles : mars, mai, juin et aout ne s'abregent pas.
  var JOURS_C = ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'];
  var MOIS_C = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
  var JOURS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  var MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];

  // Heure de Paris, jamais l'heure locale du visiteur : un client hors Europe/Paris
  // verrait sinon une date decalee et un cutoff faux.
  function maintenantParis() {
    var d = new Date();
    try {
      var p = {};
      new Intl.DateTimeFormat('en-GB', {
        timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23'
      }).formatToParts(d).forEach(function (part) { p[part.type] = part.value; });
      return { y: +p.year, m: +p.month, d: +p.day, h: (+p.hour) % 24 };
    } catch (e) {
      return { y: d.getFullYear(), m: d.getMonth() + 1, d: d.getDate(), h: d.getHours() };
    }
  }

  // Dates manipulees en UTC pur : ce sont des dates civiles, pas des instants.
  function civil(y, m, d) { return new Date(Date.UTC(y, m - 1, d)); }

  function iso(dt) {
    var m = dt.getUTCMonth() + 1, j = dt.getUTCDate();
    return dt.getUTCFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (j < 10 ? '0' : '') + j;
  }

  function libelle(dt) { return JOURS[dt.getUTCDay()] + ' ' + dt.getUTCDate() + ' ' + MOIS[dt.getUTCMonth()]; }

  function libelleCourt(dt) { return JOURS_C[dt.getUTCDay()] + ' ' + dt.getUTCDate() + ' ' + MOIS_C[dt.getUTCMonth()]; }

  function estOuvre(dt, feries) {
    var j = dt.getUTCDay();
    if (j === 0 || j === 6) return false;
    return feries.indexOf(iso(dt)) === -1;
  }

  function jourOuvreSuivant(dt, feries) {
    var d = new Date(dt.getTime()), garde = 0;
    do { d.setUTCDate(d.getUTCDate() + 1); garde++; } while (!estOuvre(d, feries) && garde < 60);
    return d;
  }

  function ajouteJoursOuvres(dt, n, feries) {
    var d = new Date(dt.getTime());
    while (n > 0) { d = jourOuvreSuivant(d, feries); n--; }
    return d;
  }

  function calcule(racine) {
    var dateEl = racine.querySelector('[data-dd-date]');
    var shipEl = racine.querySelector('[data-dd-ship]');
    if (!dateEl) return;

    function entier(attr, defaut) {
      var v = parseInt(racine.getAttribute(attr), 10);
      return isNaN(v) ? defaut : v;
    }

    var cutoff = entier('data-cutoff', 11);
    var tmin = entier('data-transport-min', 2);
    var tmax = entier('data-transport-max', 3);
    var jourMeme = racine.getAttribute('data-same-day') !== 'false';
    var feries = (racine.getAttribute('data-feries') || '').split(',').filter(function (s) { return s.length === 10; });

    var now = maintenantParis();
    var aujourdhui = civil(now.y, now.m, now.d);
    var expedition = null, mention = '';

    // Mode precommande : une date renseignee et future suffit a le declencher.
    var pre = (racine.getAttribute('data-precommande') || '').replace(/^\s+|\s+$/g, '');
    if (pre.length === 10) {
      var p = pre.split('-');
      var datePre = civil(+p[0], +p[1], +p[2]);
      if (datePre.getTime() > aujourdhui.getTime()) {
        expedition = datePre;
        mention = (racine.getAttribute('data-mention-precommande') || 'Précommande, expédition à partir du {date}')
          .replace('{date}', libelle(datePre));
      }
    }

    if (!expedition) {
      // La premiere ligne est desormais une regle fixe rendue en Liquid ("Commande avant 11 h,
      // expediee le jour meme"), vraie a toute heure : on ne la reecrit plus. Seul le mode
      // precommande la remplace, et il a deja rempli "mention" ci-dessus.
      expedition = (jourMeme && estOuvre(aujourdhui, feries) && now.h < cutoff)
        ? aujourdhui
        : jourOuvreSuivant(aujourdhui, feries);
    }

    var min = ajouteJoursOuvres(expedition, tmin, feries);
    var max = ajouteJoursOuvres(expedition, tmax, feries);

    if (min.getTime() === max.getTime()) {
      dateEl.textContent = 'Livraison estimée le ' + libelleCourt(min);
    } else if (min.getUTCMonth() === max.getUTCMonth()) {
      // Meme mois : on ne le repete pas sur la premiere date.
      dateEl.textContent = 'Livraison estimée entre ' + JOURS_C[min.getUTCDay()] + ' ' + min.getUTCDate() + ' et ' + libelleCourt(max);
    } else {
      dateEl.textContent = 'Livraison estimée entre ' + libelleCourt(min) + ' et ' + libelleCourt(max);
    }

    if (shipEl && mention) shipEl.textContent = mention;
  }

  function calculeTout() {
    var noeuds = document.querySelectorAll('[data-dd-logistique]');
    for (var i = 0; i < noeuds.length; i++) calcule(noeuds[i]);
  }

  // Ouvre l'accordeon cible et defile jusqu'a lui. Remplace les anciennes popins.
  function ouvreAncre(hash, defiler) {
    if (!hash || hash.charAt(0) !== '#' || hash.length < 2) return false;
    var cible;
    try { cible = document.querySelector(hash); } catch (e) { return false; }
    if (!cible) return false;
    var details = cible.tagName === 'DETAILS' ? cible : (cible.closest ? cible.closest('details') : null);
    if (details) details.open = true;
    if (defiler) {
      // Un bloc repliable est centre pour montrer son contenu qui vient de s'ouvrir.
      // Toute autre cible est cadree en haut : les ancres de section sont des reperes de
      // hauteur nulle, les centrer laisserait la section commencer au milieu de l'ecran.
      var cadrage = details ? 'center' : 'start';
      try { cible.scrollIntoView({ behavior: 'smooth', block: cadrage }); }
      catch (e) { cible.scrollIntoView(); }
    }
    return true;
  }

  // Accordeons exclusifs : ouvrir un bloc referme celui qui l'etait.
  // On passe par la propriete "open" et non par removeAttribute : le composant du theme
  // (accordion-disclosure, qui etend AnimatedDetails) intercepte le clic et anime la
  // transition dans son setter. Retirer l'attribut directement sauterait l'animation et
  // laisserait l'etat interne du composant desynchronise.
  // Le groupe est delimite par le prefixe d'identifiant dd-acc- : les accordeons de la FAQ,
  // du guide des tailles et des filtres de collection ne sont donc pas affectes.
  function fermeLesAutres(ouvert) {
    var tous = document.querySelectorAll('details[id^="dd-acc-"]');
    for (var i = 0; i < tous.length; i++) {
      if (tous[i] !== ouvert && tous[i].open) tous[i].open = false;
    }
  }

  // Bascule 3x / 4x de la ligne Alma. Ne touche PAS au montant : celui-ci est calcule en
  // Liquid pour chaque plan et deja present dans le HTML, on ne fait qu'afficher le bon.
  // Aucun input radio ici volontairement : la ligne vit dans product-info, sous un
  // product-rerender observe-form, et un changement d'input y declencherait un re-rendu serveur.
  function basculePlan(bouton) {
    var racine = bouton.closest ? bouton.closest('[data-dd-alma]') : null;
    if (!racine) return;
    var n = bouton.getAttribute('data-dd-alma-plan');
    var i;
    var boutons = racine.querySelectorAll('[data-dd-alma-plan]');
    for (i = 0; i < boutons.length; i++) {
      var actif = boutons[i] === bouton;
      boutons[i].classList.toggle('is-active', actif);
      boutons[i].setAttribute('aria-pressed', actif ? 'true' : 'false');
    }
    var montants = racine.querySelectorAll('[data-dd-alma-amount]');
    for (i = 0; i < montants.length; i++) {
      montants[i].classList.toggle('is-active', montants[i].getAttribute('data-dd-alma-amount') === n);
    }
  }

  function init() {
    // Delegation sur document : survit aux re-rendus sans reattachement de listener.
    document.addEventListener('click', function (e) {
      var plan = e.target && e.target.closest ? e.target.closest('[data-dd-alma-plan]') : null;
      if (plan) { basculePlan(plan); return; }

      var lien = e.target && e.target.closest ? e.target.closest('[data-dd-anchor]') : null;
      if (!lien) return;
      var hash = lien.getAttribute('href') || '';
      if (hash.charAt(0) !== '#') return;
      e.preventDefault();
      if (ouvreAncre(hash, true) && window.history && history.replaceState) {
        history.replaceState(null, '', hash);
      }
    });

    // L'evenement "toggle" ne remonte pas (il ne bulle pas), mais il traverse la phase de
    // CAPTURE : un seul listener sur le document suffit donc, et il survit aux re-rendus
    // sans avoir a etre reattache sur chaque accordeon.
    // Pas de risque de boucle : fermer un bloc emet un toggle, ignore car open est alors faux.
    document.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d || d.tagName !== 'DETAILS' || !d.open) return;
      if (!d.id || d.id.indexOf('dd-acc-') !== 0) return;
      fermeLesAutres(d);
    }, true);

    // Le snippet vit dans product-info, enveloppe d'un product-rerender observe-form :
    // a chaque changement de variant le HTML est re-rendu cote serveur et la date
    // redevient le texte de repli. Sans ce recalcul, la date disparait au changement
    // de couleur (defaut de l'ancien script).
    if (document.body) {
      document.body.addEventListener('product:rerender', function () { calculeTout(); }, true);
    }

    // Arrivee directe avec le hash dans l'URL : on ouvre tout de suite, puis on
    // defile au chargement complet pour ne pas lutter avec le defilement natif.
    if (window.location.hash) ouvreAncre(window.location.hash, false);
    window.addEventListener('load', function () {
      if (window.location.hash) ouvreAncre(window.location.hash, true);
    });

    calculeTout();
  }

  if (!window.ddLogistiqueInit) {
    window.ddLogistiqueInit = true;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }
})();
